import pageMeta from 'btm-pageMeta/pageMeta'; //eslint-disable-line import/no-unresolved, import/extensions

import {
    getPaywallVisitCount,
    getVisitorData,
    getLocalSWID,
    copyProps,
    findQueryParamCaseInsensitive,
    getUnid,
    getAllQueryStringParams,
    getDSSID
} from './utils';
import { getSubscriptionInfo, getEntitlements } from './subscription-helper';
import getOneIDPromiseWrapper from './one-id-promise';
import getDelayedValues from './delayed-values';

export default function (s, propsToExclude) {
    let acquiredDisneyInfo;
    const trackingConfig = window.espnTrackingConfig;
    /* eslint-disable quote-props */
    let contextData = {
        'entitlements': 'not applicable',
        'paywallvisitcount': getPaywallVisitCount(),
        'paywallshown': 'yes',
        'site': 'espnplus',
        'swid': getLocalSWID(),
        'purchasemethod': 'not applicable',
        'contenttype': 'paywall',
        'section': 'espnplus',
        // default (overridden if logged in below) Registered:Logged in Active |
        // Registered:Logged in Passive | anonymous
        'loginstatus': 'anonymous',
        'premium': 'premium-no',
        'registrationtype': 'unknown',
        'lang': 'en_us', // getLocale()
        'sport': 'no sport',
        'league': 'no league',
        'edition': 'en-us',
        'birthage': 'unknown',
        'gender': 'not applicable',
        'webAppName': 'espnplus'
    };
    /* eslint-enable quote-props */
    const optimizelyVar = window.btmOptimizelyVar;
    if (optimizelyVar) {
        contextData.optimizelyvar = optimizelyVar;
    }

    const visitorData = getVisitorData(s);
    copyProps(visitorData, contextData);
    copyProps(window.btmExtraTrackingProps || {}, contextData);

    // set optional query string values
    [
        ['addata', 'internalmkt'],
        ['ex_cid', 'externalmkt']
    ].forEach((queryParam) => {
        const pramValue = findQueryParamCaseInsensitive(queryParam[0]);
        if (pramValue) {
            contextData[queryParam[1]] = pramValue;
        }
    });

    const queryStringParams = getAllQueryStringParams();
    // pass-through any querystring that starts with "om-"
    Object.keys(queryStringParams).forEach((key) => {
        if (key.indexOf('om-') === 0) {
            contextData[key.substr(3)] = queryStringParams[key];
        }
        if (key === 'cid') {
            contextData[key] = queryStringParams[key];
        }
    });

    const allPromises = [
        getUnid(),
        getSubscriptionInfo(),
        getDelayedValues(trackingConfig),
        getEntitlements(),
        getDSSID()
    ];

    if (acquiredDisneyInfo) {
        copyProps(acquiredDisneyInfo, contextData);
    } else {

        /** Disney One ID should not be used when disabled by the section_config (i.e. Paywalls) */
        const oneIdEnabled = JSON.parse(pageMeta.oneIdEnabled || false);
        if (oneIdEnabled) {
            allPromises.push(getOneIDPromiseWrapper());
        }
    }


    return Promise.all(allPromises).then((results) => {
        /** Unid */
        const foundUnid = results[0];
        if (foundUnid) {
            contextData.unid = foundUnid;
        }

        /** Subscription info */
        const {
            subscriptionType,
            purchaseMethod
        } = results[1];

        if (subscriptionType) {
            contextData.subscribertype = subscriptionType;
        }

        if (purchaseMethod) {
            contextData.purchasemethod = purchaseMethod;
        }

        const delayedValues = results[2];
        if (delayedValues) {
            const {
                contextData: overrideContextData = {}
            } = delayedValues;

            contextData = Object.assign({}, contextData, overrideContextData);
        }

        const entitlements = results[3];
        if (entitlements) {
            contextData.entitlements = entitlements;
        }

        const DSSID = results[4];
        if (DSSID) {
            contextData.DSSID = DSSID;
            window.dssDataLayer.DSSID = DSSID;
        }


        return contextData;

    }).catch((err) => {

        console.error('Error gathering async analytics props', err);

        // resolve with what we can get.
        return contextData;

    }).then((ctxData) => {

        // exclude specified props
        if (propsToExclude && propsToExclude.length) {
            propsToExclude.forEach((prop) => {
                delete ctxData[prop];
            });
        }

        return ctxData;
    });
}

